export default __webpack_public_path__ + "static/media/trazado.3f6b4fef.svg";